var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VLayout',{attrs:{"upline":"","title":_vm.title,"subtitle":_vm.$t('addressform.subtitle')}},[_c('VAddressForm',{staticClass:"mb-3",attrs:{"a_uuid":_vm.aUuid}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }